import React from 'react'
import type { ComponentProps, PartData } from '@enonic/react-components'
import KeyDataPrototype from './prototype/KeyData'
import type { KeyDataColour, KeyDataItem } from './prototype/KeyData/types'

type KeyDataPartData = {
	overline?: string
	title?: string
	intro?: string
	cards?: {
		value?: string
		label?: string
		text?: string
		colour: string
	}[]
}

export const KeyData = ({ data }: ComponentProps<PartData>) => {
	const { overline, title, intro, cards = [] } = (data || {}) as KeyDataPartData

	// Cards are optional in the schema, so a part can end up with no editor content at
	// all — collapse it rather than ship an empty grid. A heading alone still renders.
	if (cards.length === 0 && !overline && !title && !intro) {
		return null
	}

	// `colour` is a ComboBox value constrained to the prototype's colour keys by the part
	// schema, but it reaches the view as a plain string, so cast rather than re-validate —
	// the prototype falls back to `primary` on anything it does not recognise.
	const items: KeyDataItem[] = cards.map((card) => ({
		value: card.value,
		label: card.label,
		text: card.text,
		colour: card.colour as KeyDataColour,
	}))

	return <KeyDataPrototype items={items} overline={overline} title={title} intro={intro} isPart />
}
